import { Injectable } from '@angular/core';
import { RxapStaticDataSource, StaticDataSource } from 'eurogard-data-source';
import { ControlOptions } from '@rxap/utilities';

@Injectable()
@RxapStaticDataSource({
  id: 'country-options',
  data: [
    {
      value: 'Deutschland',
      display: 'Deutschland',
    },
    {
      value: 'Österreich',
      display: 'Österreich',
    },
    {
      value: 'Schweiz',
      display: 'Schweiz',
    },
    {
      value: 'Belgien',
      display: 'Belgien',
    },
    {
      value: 'Bulgarien',
      display: 'Bulgarien',
    },
    {
      value: 'Dänemark',
      display: 'Dänemark',
    },
    {
      value: 'Estland',
      display: 'Estland',
    },
    {
      value: 'Finnland',
      display: 'Finnland',
    },
    {
      value: 'Frankreich',
      display: 'Frankreich',
    },
    {
      value: 'Griechenland',
      display: 'Griechenland',
    },
    {
      value: 'Irland',
      display: 'Irland',
    },
    {
      value: 'Italien',
      display: 'Italien',
    },
    {
      value: 'Kroatien',
      display: 'Kroatien',
    },
    {
      value: 'Lettland',
      display: 'Lettland',
    },
    {
      value: 'Litauen',
      display: 'Litauen',
    },
    {
      value: 'Luxemburg',
      display: 'Luxemburg',
    },
    {
      value: 'Malta',
      display: 'Malta',
    },
    {
      value: 'Niederlande',
      display: 'Niederlande',
    },
    {
      value: 'Polen',
      display: 'Polen',
    },
    {
      value: 'Portugal',
      display: 'Portugal',
    },
    {
      value: 'Rumänien',
      display: 'Rumänien',
    },
    {
      value: 'Slowakei',
      display: 'Slowakei',
    },
    {
      value: 'Slowenien',
      display: 'Slowenien',
    },
    {
      value: 'Spanien',
      display: 'Spanien',
    },
    {
      value: 'Schweden',
      display: 'Schweden',
    },
    {
      value: 'Tschechien',
      display: 'Tschechien',
    },
    {
      value: 'Ungarn',
      display: 'Ungarn',
    },
    {
      value: 'Vereinigtes Königreich',
      display: 'Vereinigtes Königreich',
    },
    {
      value: 'Zypern',
      display: 'Zypern',
    },
  ],
})
export class CountryOptionsDataSource extends StaticDataSource<ControlOptions> {
}
